import { render, staticRenderFns } from "./update-status-sue-panel.vue?vue&type=template&id=29bda8df&"
import script from "./update-status-sue-panel.vue?vue&type=script&lang=js&"
export * from "./update-status-sue-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports